import React from "react";
import { FiCheck } from "react-icons/fi";

const Stepper = ({ currentStep = 1, history }) => {
  const steps = [
    { id: 1, title: "Assessment Code" },
    { id: 2, title: "Upload Users" },
    { id: 3, title: "Create Team" },
    { id: 4, title: "Results" },
  ];

  const gotoPageNo = (pageNo) => {
    if (pageNo === 1) history.push("/assessment/overview");
    else if (pageNo === 2) history.push("/assessment/myusers");
    else if (pageNo === 3) history.push("/assessment/myteams");
    else if (pageNo === 4) history.push("/assessment/myresults");
  };

  return (
    <div className="flex items-center justify-center max-w-4xl pb-4 mx-auto">
      {steps.map((step, index) => {
        const isCompleted = step.id < currentStep;
        const isCurrent = step.id === currentStep;

        return (
          <React.Fragment key={step.id}>
            <div
              onClick={() => gotoPageNo(step.id)}
              className="flex flex-col items-center min-w-[100px] cursor-pointer"
            >
              <div
                className={`w-10 h-10 rounded-xl font-semibold flex items-center justify-center transition-all duration-300
                  ${
                    isCompleted || isCurrent
                      ? "bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white shadow-md shadow-indigo-200"
                      : "bg-slate-300 text-gray-500"
                  }
                `}
              >
                {isCompleted ? <FiCheck size={20} /> : step.id}
              </div>

              <span
                className={`
                  mt-2 text-base whitespace-nowrap transition-all duration-300
                  ${
                    isCompleted || isCurrent
                      ? "font-semibold bg-gradient-to-r from-[#673AB7] to-[#1976D2] bg-clip-text text-transparent"
                      : "font-medium text-gray-500"
                  }
                `}
              >
                {step.title}
              </span>
            </div>

            {/* Connector */}
            {index < steps.length - 1 && (
              <div
                className={`
                  flex-1 h-1 mx-4 self-center mb-6 transition-all duration-500
                  ${
                    step.id < currentStep
                      ? "bg-gradient-to-r from-[#673AB7] to-[#1976D2]"
                      : "bg-slate-300"
                  }
                `}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Stepper;